import React from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import "../../styles/Admin.css";
import "../../styles/global.css";

const AdminNavbar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    localStorage.removeItem("adminToken");
    navigate("/admin/login");
  };

  const isActive = (path) => location.pathname === path;

  return (
    <nav style={{ background: "#000", color: "#fff", padding: "0 24px", marginBottom: 24 }}>
      <div className="container" style={{ maxWidth: 1200, margin: "0 auto" }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", height: 56 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 32 }}>
            <Link
              to="/admin/dashboard"
              style={{
                color: "#fff",
                textDecoration: "none",
                fontWeight: 600,
                fontSize: 16,
              }}
            >
              Admin Panel
            </Link>
            <div style={{ display: "flex", gap: 8 }}>
              <Link
                to="/admin/dashboard"
                className={isActive("/admin/dashboard") ? "admin-nav-active" : ""}
                style={{
                  color: "#fff",
                  textDecoration: "none",
                  padding: "8px 12px",
                  borderRadius: 6,
                  fontSize: 14,
                  opacity: isActive("/admin/dashboard") ? 1 : 0.7,
                  background: isActive("/admin/dashboard") ? "rgba(255,255,255,0.1)" : "transparent",
                }}
              >
                Dashboard
              </Link>
              <Link
                to="/admin/users"
                className={isActive("/admin/users") || location.pathname.startsWith("/admin/users/") ? "admin-nav-active" : ""}
                style={{
                  color: "#fff",
                  textDecoration: "none",
                  padding: "8px 12px",
                  borderRadius: 6,
                  fontSize: 14,
                  opacity: isActive("/admin/users") || location.pathname.startsWith("/admin/users/") ? 1 : 0.7,
                  background: (isActive("/admin/users") || location.pathname.startsWith("/admin/users/")) ? "rgba(255,255,255,0.1)" : "transparent",
                }}
              >
                Users
              </Link>
              <Link
                to="/admin/settings/pricing"
                className={isActive("/admin/settings/pricing") ? "admin-nav-active" : ""}
                style={{
                  color: "#fff",
                  textDecoration: "none",
                  padding: "8px 12px",
                  borderRadius: 6,
                  fontSize: 14,
                  opacity: isActive("/admin/settings/pricing") ? 1 : 0.7,
                  background: isActive("/admin/settings/pricing") ? "rgba(255,255,255,0.1)" : "transparent",
                }}
              >
                Pricing
              </Link>
              <Link
                to="/admin/settings/visibility"
                className={isActive("/admin/settings/visibility") ? "admin-nav-active" : ""}
                style={{
                  color: "#fff",
                  textDecoration: "none",
                  padding: "8px 12px",
                  borderRadius: 6,
                  fontSize: 14,
                  opacity: isActive("/admin/settings/visibility") ? 1 : 0.7,
                  background: isActive("/admin/settings/visibility") ? "rgba(255,255,255,0.1)" : "transparent",
                }}
              >
                Visibility
              </Link>
              <Link
                to="/admin/settings/menu"
                className={isActive("/admin/settings/menu") ? "admin-nav-active" : ""}
                style={{
                  color: "#fff",
                  textDecoration: "none",
                  padding: "8px 12px",
                  borderRadius: 6,
                  fontSize: 14,
                  opacity: isActive("/admin/settings/menu") ? 1 : 0.7,
                  background: isActive("/admin/settings/menu") ? "rgba(255,255,255,0.1)" : "transparent",
                }}
              >
                Menu Manager
              </Link>
              <Link
                to="/admin/cron/logs"
                className={isActive("/admin/cron/logs") ? "admin-nav-active" : ""}
                style={{
                  color: "#fff",
                  textDecoration: "none",
                  padding: "8px 12px",
                  borderRadius: 6,
                  fontSize: 14,
                  opacity: isActive("/admin/cron/logs") ? 1 : 0.7,
                  background: isActive("/admin/cron/logs")
                    ? "rgba(255,255,255,0.1)"
                    : "transparent",
                }}
              >
                Cron Logs
              </Link>
            </div>
          </div>
          <button
            onClick={handleLogout}
            className="btn-secondary"
            style={{
              background: "rgba(255,255,255,0.1)",
              color: "#fff",
              border: "1px solid rgba(255,255,255,0.2)",
            }}
          >
            Logout
          </button>
        </div>
      </div>
    </nav>
  );
};

export default AdminNavbar;

